export const ANALYTICS_EVENTS = {
    PAGE_VIEWED: 'page_viewed',

    LOGIN_COMPLETED: 'login_completed',
    LOGOUT_COMPLETED: 'logout_completed',
    MAGIC_LINK_REQUESTED: 'magic_link_requested',
    MAGIC_LINK_VERIFIED: 'magic_link_verified',

    REGISTRATION_STARTED: 'registration_started',
    REGISTRATION_EMAIL_COMPLETED: 'registration_email_completed',
    REGISTRATION_MAGIC_LINK_SENT: 'registration_magic_link_sent',
    REGISTRATION_MAGIC_LINK_RESENT: 'registration_magic_link_resent',
    REGISTRATION_MAGIC_LINK_VERIFIED: 'registration_magic_link_verified',
    REGISTRATION_DETAILS_VIEWED: 'registration_details_viewed',
    REGISTRATION_MAYBE_LATER_CLICKED: 'registration_maybe_later_clicked',
    REGISTRATION_DETAILS_COMPLETED: 'registration_details_completed',
    REGISTRATION_CONTINUE_TO_ONBOARDING_CLICKED: 'registration_continue_to_onboarding_clicked',
    REGISTRATION_EXPLORE_CLICKED: 'registration_explore_clicked',

    ONBOARDING_MAYBE_LATER_CLICKED: 'onboarding_maybe_later_clicked',
    ONBOARDING_STARTED: 'onboarding_started',
    ONBOARDING_STEP_VIEWED: 'onboarding_step_viewed',
    ONBOARDING_STEP_COMPLETED: 'onboarding_step_completed',
    ONBOARDING_COMPLETED: 'onboarding_completed',

    DISCOVERY_OPENED: 'discovery_opened',
    DISCOVERY_COMPANY_VIEWED: 'discovery_company_viewed',
    DISCOVERY_CITY_VIEWED: 'discovery_city_viewed',
    DISCOVERY_COUNTRY_VIEWED: 'discovery_country_viewed',
    DISCOVERY_SEARCH_USED: 'discovery_search_used',
    DISCOVERY_FILTER_APPLIED: 'discovery_filter_applied',
    DISCOVERY_VIEW_SWITCHED: 'discovery_view_switched',
    DISCOVERY_CITY_INSIGHTS_VIEWED: 'discovery_city_insights_viewed',
    DISCOVERY_CITY_SALARY_VIEWED: 'discovery_city_salary_viewed',

    FAVORITE_COMPANY_ADDED: 'favorite_company_added',
    FAVORITE_COMPANY_REMOVED: 'favorite_company_removed',
    FAVORITE_CITY_ADDED: 'favorite_city_added',
    FAVORITE_CITY_REMOVED: 'favorite_city_removed',
    FAVORITE_COUNTRY_ADDED: 'favorite_country_added',
    FAVORITE_COUNTRY_REMOVED: 'favorite_country_removed',

    COMPANY_WEBSITE_CLICKED: 'company_website_clicked',
    COMPANY_OPENED: 'company_opened',
};